import { api } from 'Service';
import { apiViaCep } from 'View/Service/viacep';

import autenticacao from './Autenticacao';
import config from './Config';

export default {
    config,
    autenticacao,
    [api.reducerPath]: api.reducer,
    [apiViaCep.reducerPath]: apiViaCep.reducer,
};
